export const formatDate = (v: any) => {
   
  if (!v) return "-";

  // Se vier "YYYY-MM-DD", monta como data local (evita -1 dia)
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
    
    const [y, m, d] = v.split("-").map(Number);
    return new Date(y, m - 1, d).toLocaleDateString("pt-BR");
  }

  // fallback se vier Date mesmo
  const dt = new Date(v);
  dt.setDate(dt.getDate() + 1); // corrige possível -1 dia por timezone
  if (Number.isNaN(dt.getTime())) return "-";

  return `${String(dt.getDate()).padStart(2, "0")}/${String(
    dt.getMonth() + 1
  ).padStart(2, "0")}/${dt.getFullYear()}`;
};
export const formatMoney = (v: any) =>
    typeof v === "number"
        ? v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        : "-";

export const maskCpfCnpj = (digits: string) => {
    const v = (digits || "").replace(/\D/g, "");
    if (v.length <= 11) {
        return v
            .replace(/^(\d{3})(\d)/, "$1.$2")
            .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
            .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
    }
    return v
        .replace(/^(\d{2})(\d)/, "$1.$2")
        .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
        .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, "$1.$2.$3/$4-$5");
};